<template>
    <div id="stepper">
        <div class="stepper-container">
            <div class="item-container">
                <div
                    v-for="(tab, index) in tabInfo"
                    :key="index"
                    @click="itemClickHandler(index)"
                    :class="index === activeTab ? 'item active' : 'item' && tab.isComplete ? 'item complete' : 'item'"
                >
                    <div class="logo" :class="{ completed: isCompleted(index) }">
                        <div v-if="isCompleted(index)">{{ index + 1 }}</div>
                        <DynamicSvg v-else :name="tab.logo" />
                    </div>
                    <div class="content">
                        {{ tab.title }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DynamicSvg from "../../DynamicSvg.vue";

export default {
    components: { DynamicSvg },
    name: "Stepper",
    props: ["tabInfo", "activeTab", "isSelectable"],
    data() {
        return {};
    },
    methods: {
        itemClickHandler(index) {
            if (this.tabInfo[index].isSelectable) {
                this.tabIndex = index;
                this.$emit("changeTab", index);
            }
        },
        isCompleted(index) {
            return index < this.activeTab;
        },
    },
};
</script>

<style lang="scss">
#stepper {
    width: 100%;
    height: 100%;
    .stepper-container {
        width: 100%;
        height: 100%;
        margin: 0 auto;

        .header {
            display: flex;
            font-size: 22px;
            color: #1f1f1f;
            font-weight: 600;
            margin-bottom: 35px;

            .tab-info {
                color: #848484;
                margin-left: 10px;
            }
        }

        .item-container {
            width: 100%;
            height: auto;
            display: flex;
            flex-wrap: wrap;
            flex-direction: column;
            gap: 15px;
            align-items: stretch;
            .item {
                display: flex;
                align-items: center;
                cursor: pointer;
                color: white;
                gap: 10px;
                white-space: nowrap;
                padding-right: 30px;
                position: relative;
                transition: 1s all;

                &.active {
                    &::after {
                        content: "";
                        position: absolute;
                        right: 0;
                        background: #ec4b1d;
                        width: 6px;
                        height: 100%;
                        border-radius: 10px 4px 4px 10px;
                    }
                }

                .logo {
                    max-width: 40px;
                    max-height: 40px;
                    width: 40px;
                    height: 40px;
                    padding: 10px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background-color: #ebebeb;
                    border-radius: 99999px;

                    &.completed {
                        font-size: 18px;
                        font-weight: bold;
                        background: #ec4b1d;
                        color: white;
                    }
                    .logo-svg {
                        width: 100%;
                        height: 100%;
                    }

                    svg {
                        fill: #848484;

                        g {
                            fill: #848484;
                        }

                        path {
                            fill: #848484 !important;
                        }
                    }
                }

                .content {
                    margin: 0;
                    font-size: 20px;
                    font-weight: 10px;
                    color: black;
                }
            }

            .active {
                .logo {
                    border: 1px solid #ec4b1d;

                    svg {
                        fill: #ec4b1d;

                        g {
                            fill: #ec4b1d;
                        }

                        path {
                            fill: #ec4b1d !important;
                        }
                    }
                }
            }

            .complete {
                .logo {
                    background-color: #ec4b1d;
                    border: 1px solid #ec4b1d;

                    svg {
                        fill: #fff;

                        g {
                            fill: #fff;
                        }

                        path {
                            fill: #fff !important;
                        }
                    }
                }
            }
        }
    }
}
</style>
